<template>
  <v-navigation-drawer
    v-model="drawerShow"
    fixed
    temporary
    color="#277FAF"
    width="100%"
    key="navigation"
  >
    <div class="navigation_grid">
      <div v-if="userType === 'superadmin' || userRoleAbilities">
        <v-list v-if="fullScreen && drawerShow">
          <v-list-item
            @click="fullScreen = null"
            :class="drawerShow ? 'show' : ''"
            style="animation-delay: 0.1s"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              aria-hidden="true"
              width="28"
              height="28"
              preserveAspectRatio="xMidYMid meet"
              viewBox="0 0 24 24"
              class="ml-1"
            >
              <path
                d="M13.939 4.939L6.879 12l7.06 7.061l2.122-2.122L11.121 12l4.94-4.939z"
                fill="white"
              />
            </svg>
            <div class="d-flex align-center">
              <BaseIcon class="mr-2" :icon="fullScreen.icon" color="white" />
              <span class="white--text">
                {{ fullScreen.text }}
              </span>
            </div>
          </v-list-item>
          <template v-for="(firstItem, firstItemKey) in fullScreen.pages">
            <template v-if="Array.isArray(firstItem)">
              <template
                v-if="firstItem.filter((i) => (i.access !== undefined ? i.access : true)).length"
              >
                <template
                  v-for="(secondItem, secondItemKey) in firstItem.filter((i) =>
                    i.access !== undefined ? i.access : true,
                  )"
                >
                  <HeaderMobileMenuListItem
                    :item="secondItem"
                    :key="'button_' + firstItemKey + '_' + secondItemKey"
                    :drawerShow="drawerShow"
                    :delay="secondItemKey + 2"
                    child
                  />
                </template>
                <v-divider
                  v-if="fullScreen.pages.length - 1 != firstItemKey"
                  class="white mb-2"
                  :class="drawerShow ? 'show' : ''"
                  :style="'animation-delay:' + (firstItem + 2) / 10 + 's; opacity: 0'"
                  :key="'divider_' + firstItemKey"
                />
              </template>
            </template>
            <template v-else>
              <HeaderMobileMenuListItem
                :item="firstItem"
                :key="'button_' + firstItemKey"
                :drawerShow="drawerShow"
                :delay="firstItemKey + 2"
                child
              />
            </template>
          </template>
        </v-list>
        <v-list v-if="!fullScreen && drawerShow">
          <template v-for="(button, key) in buttons">
            <div :key="'buttons' + key" v-if="button.access !== undefined ? button.access : true">
              <v-list-group
                v-if="button.pages && !button.fullScreen"
                :class="drawerShow ? 'show' : ''"
                :style="'animation-delay:' + (key + 1) / 10 + 's'"
                append-icon=""
              >
                <template v-slot:activator>
                  <v-list-item-title>
                    <BaseIcon v-if="button.icon" :icon="button.icon" color="#ffffff" />
                    <span class="mt-1 white--text">
                      {{ button.text }}
                    </span>
                  </v-list-item-title>
                </template>
                <template v-for="(page, p) in button.pages">
                  <HeaderMobileMenuListItem
                    :item="page"
                    :key="'page_' + p"
                    :drawerShow="drawerShow"
                    :delay="p + 1"
                    class="show pl-16 white--text"
                  />
                </template>
              </v-list-group>
              <HeaderMobileMenuListItem
                v-else
                :item="button"
                :drawerShow="drawerShow"
                :delay="key + 1"
                @getFullScreen="changeFullScreen"
              />
            </div>
          </template>
        </v-list>
      </div>
      <div class="append_grid">
        <div class="f12">
          © {{ new Date().getFullYear() }}
          {{ localStorage.translations.pages.footer.text['vse-prava-zashchishcheny'] }}
        </div>
        <div class="append_grid_inner">
          <a
            class="link"
            href="https://apps.apple.com/fi/app/proapp-2-0/id1667509098"
            target="_blank"
            rel="nofollow noopener"
          >
            <img src="~/assets/img/apple_store.svg" alt="apple-store" />
          </a>
          <a
            class="link"
            href="https://play.google.com/store/apps/details?id=com.siacom.proapp"
            target="_blank"
            rel="nofollow noopener"
          >
            <img src="~/assets/img/google_play.svg" alt="google-play" />
          </a>
        </div>
        <div>
          <img src="~/assets/img/logo_menu.svg" alt="ProApp" />
        </div>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import HeaderMobileMenuListItem from 'components/header/HeaderMobileMenuListItem'
export default {
  name: 'HeaderMobileMenu',
  components: { HeaderMobileMenuListItem },
  props: {
    drawer: Boolean,
    buttons: Array,
  },
  data() {
    return {
      fullScreen: null,
      drawerShow: false,
    }
  },
  watch: {
    drawer() {
      this.drawerShow = this.drawer
      this.fullScreen = null
    },
    drawerShow() {
      this.$emit('update:drawer', this.drawerShow)
    },
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
    userData() {
      return this.$store.getters['user/userData']
    },
    userRoleAbilities() {
      return this.$store.getters['user/userRoleAbilities']
    },
    userType() {
      return this.$store.getters['user/userType']
    },
  },
  methods: {
    onExit() {
      this.$emit('exit', true)
    },
    onArrayFormat() {
      firstItem.filter((i) =>
        i.access
          ? $userCheckAccess({
              abilities: i.access,
            })
          : true,
      )
    },
    changeFullScreen(value) {
      this.fullScreen = value
    },
  },
}
</script>
<style lang="scss">
.v-navigation-drawer {
  z-index: 11 !important;
}
</style>

<style lang="scss" scoped>
:deep() .v-navigation-drawer {
  &__content {
    padding: 60px 0 0;
    .v-list-group {
      transition-property: all;
      opacity: 0;
      transform: translateX(-50px);
    }
    .v-list-item {
      display: grid;
      grid-template-columns: 40px 1fr auto;
      justify-items: left;
      grid-gap: 10px;
      grid-template-rows: auto;
      color: white !important;
      transition-property: all;
      opacity: 0;
      transform: translateX(-50px);
      margin-bottom: 10px;

      &__title {
        display: grid;
        grid-template-columns: 40px 1fr auto;
        justify-items: left;
        grid-gap: 10px;
        grid-template-rows: auto;
        transition-property: all;
      }
    }

    .show {
      animation-name: show;
      animation-duration: 0.5s;
      animation-timing-function: ease-in-out;
      animation-fill-mode: forwards;

      .v-list-item {
        animation-name: show;
        animation-duration: 0.5s;
        animation-timing-function: ease-in-out;
        animation-fill-mode: forwards;
      }
    }

    .navigation_grid {
      position: relative;
      display: grid;
      height: 100%;
      grid-template-columns: 1fr;
      grid-template-rows: 1fr auto;
      z-index: 200;
    }
  }
}
.append_grid {
  display: grid;
  grid-template-rows: auto auto auto;
  grid-template-columns: 1fr;
  grid-gap: 20px;
  justify-items: center;
  padding: 30px;
  border-top: 1px solid white;

  &_inner {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr 1fr;
    grid-gap: 20px;

    * {
      max-width: 100%;
    }
  }

  * {
    color: white !important;
  }
}
@keyframes show {
  0% {
    opacity: 0;
    transform: translateX(-50px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
</style>